import { MdErrorOutline, MdHourglassEmpty, MdInbox, MdRefresh } from "react-icons/md";
import { DATA_TABLE_STATE_PANEL } from "lib/dataTableClasses";

export function DataTableLoadingState({ message }: { message: string }) {
  return (
    <div className={DATA_TABLE_STATE_PANEL} role="status" aria-live="polite">
      <MdHourglassEmpty className="h-8 w-8 animate-pulse text-brand-500" />
      <p className="text-sm font-medium text-gray-600 dark:text-gray-300">{message}</p>
    </div>
  );
}

export function DataTableEmptyState({
  title,
  hint,
}: {
  title: string;
  hint?: string;
}) {
  return (
    <div className={DATA_TABLE_STATE_PANEL}>
      <MdInbox className="h-8 w-8 text-gray-400 dark:text-gray-500" />
      <p className="text-sm font-semibold text-gray-600 dark:text-gray-300">{title}</p>
      {hint ? (
        <p className="max-w-sm text-center text-xs text-gray-500 dark:text-gray-400">
          {hint}
        </p>
      ) : null}
    </div>
  );
}

export function DataTableErrorState({
  message,
  isArabic,
  onRetry,
}: {
  message: string;
  isArabic: boolean;
  onRetry?: () => void;
}) {
  return (
    <div className={DATA_TABLE_STATE_PANEL}>
      <MdErrorOutline className="h-8 w-8 text-red-500" />
      <p className="max-w-md text-center text-sm font-semibold text-red-600 dark:text-red-400">
        {message}
      </p>
      {onRetry ? (
        <button
          type="button"
          onClick={onRetry}
          className="mt-1 inline-flex items-center gap-1.5 rounded-lg bg-gray-100 px-3 py-1.5 text-xs font-semibold text-gray-700 hover:bg-gray-200 dark:bg-white/10 dark:text-white"
        >
          <MdRefresh className="h-3.5 w-3.5" />
          {isArabic ? "إعادة المحاولة" : "Retry"}
        </button>
      ) : null}
    </div>
  );
}
